// Module
var code = "<div class=\"vui-select__option\" tabindex=\"{{$id}}\" ng-transclude></div>\n";
// Exports
module.exports = code;